/*! For license information please see exclusive_main.js.LICENSE.txt */ ! function () {
  var e = {
      "./src/js/main.js": function (e, t, s) {
        var r, n = s("jquery"),
          i = (document.documentElement.clientHeight || window.innerHeight, document.documentElement.clientWidth || window.innerWidth),
          o = n(window).scrollTop();
        n(window).on("scroll", (function (e) {
            var t = n(window).scrollTop();
            t > o ? "down" : "up", o = t, n(n.CN(".product-container .section")).each((function (e, t) {
              n(t).data("section")
            }))
          })), r = n(n.CN(".section-first .item-box")), new Swiper("#swipers1", {
            autoplay: {
              delay: 5e3,
              disableOnInteraction: !1
            },
            enabled: r.length > 1,
            loop: !0,
            pagination: {
              el: ".swiper-pagination",
              renderBullet: function (e, t) {
                return '<div class="' + t + '"><span></span></div>'
              }
            },
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev"
            }
          }), n(n.CN(".section-third .item")).on("click", (function (e) {
            n(n.CN(".section-third .item")).removeClass(n.CN("active")), n(n.CN(".section-third .picture")).removeClass(n.CN("active")), n(this).addClass(n.CN("active")), n(n.CN(".section-third .status" + e.currentTarget.dataset.status)).addClass(n.CN("active"))
          })),
          function () {
            function e(e) {
              return n(n.CN(".section-fifth ." + e))
            }

            function t(e) {
              return {
                height: e,
                duration: .3,
                ease: "power1.out"
              }
            }
            var s = {
                rotation: 45,
                duration: .3,
                delay: -.3,
                ease: "power1.out"
              },
              r = {
                opacity: 0,
                duration: .1
              },
              o = gsap.timeline({
                paused: !0
              }),
              a = gsap.timeline({
                paused: !0
              }),
              c = gsap.timeline({
                paused: !0
              }),
              u = gsap.timeline({
                paused: !0
              }),
              p = gsap.timeline({
                paused: !0
              });

            function d(e) {
              1 != e && o.reverse(), 2 != e && a.reverse(), 3 != e && c.reverse(), 4 != e && u.reverse(), 5 != e && p.reverse()
            }
            o.to(e("pBox1"), t(i > 750 ? 84 : 135)), o.to(e("topsvg1"), s), o.to(e("topsvg1"), r), a.to(e("pBox2"), t(i > 750 ? 65 : 80)), a.to(e("topsvg2"), s), a.to(e("topsvg2"), r), c.to(e("pBox3"), t(i > 750 ? 214 : 366)), c.to(e("topsvg3"), s), c.to(e("topsvg3"), r), u.to(e("pBox4"), t(i > 750 ? 106 : 173)), u.to(e("topsvg4"), s), u.to(e("topsvg4"), r), p.to(e("pBox5"), t(i > 750 ? 63 : 115)), p.to(e("topsvg5"), s), p.to(e("topsvg5"), r), o.reversed(!o.reversed()), a.reversed(!a.reversed()), c.reversed(!c.reversed()), u.reversed(!u.reversed()), p.reversed(!p.reversed()), o.play(), n(n.CN(".section-fifth .topic")).on("click", (function (e) {
              switch (e.currentTarget.dataset.pbox) {
                case "1":
                  d(1), o.reversed() ? o.play() : o.reverse();
                  break;
                case "2":
                  d(2), a.reversed() ? a.play() : a.reverse();
                  break;
                case "3":
                  d(3), c.reversed() ? c.play() : c.reverse();
                  break;
                case "4":
                  d(4), u.reversed() ? u.play() : u.reverse();
                  break;
                case "5":
                  d(5), p.reversed() ? p.play() : p.reverse()
              }
            }))
          }()
      },
      "./src/utils/index.js": function (e, t, s) {
        ! function (e) {
          e.extend({
            CN: function (e) {
              return e.startsWith(".") ? e.split(" ").map((function (e) {
                return ".".concat("exclusive_").concat(e.slice(1))
              })).join(" ") : "exclusive_" + e
            }
          })
        }(s("jquery"))
      },
      "./src/index.html": function (e, t, s) {
        "use strict";
        var r = s("./node_modules/html-loader/dist/runtime/getUrl.js"),
          n = s.n(r),
          i = new URL(s("./src/assets/images/section2_status1.jpg"), s.b),
          o = new URL(s("./src/assets/images/section2_status2.jpg"), s.b);
        n()(i), n()(o)
      },
      "./node_modules/html-loader/dist/runtime/getUrl.js": function (e) {
        "use strict";
        e.exports = function (e, t) {
          return t || (t = {}), e ? (e = String(e.__esModule ? e.default : e), t.hash && (e += t.hash), t.maybeNeedQuotes && /[\t\n\f\r "'=<>`]/.test(e) ? '"'.concat(e, '"') : e) : e
        }
      },
      "./src/assets/images/section2_status1.jpg": function (e, t, s) {
        "use strict";
        e.exports = s.p + "files/exclusive_section2_status1.jpg"
      },
      "./src/assets/images/section2_status2.jpg": function (e, t, s) {
        "use strict";
        e.exports = s.p + "files/exclusive_section2_status2.jpg"
      },
      jquery: function (e) {
        "use strict";
        e.exports = $
      }
    },
    t = {};

  function s(r) {
    var n = t[r];
    if (void 0 !== n) return n.exports;
    var i = t[r] = {
      exports: {}
    };
    return e[r](i, i.exports, s), i.exports
  }
  s.m = e, s.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default
      } : function () {
        return e
      };
      return s.d(t, {
        a: t
      }), t
    }, s.d = function (e, t) {
      for (var r in t) s.o(t, r) && !s.o(e, r) && Object.defineProperty(e, r, {
        enumerable: !0,
        get: t[r]
      })
    }, s.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t)
    }, s.p = "./", s.b = document.baseURI || self.location.href,
    function () {
      "use strict";
      s("./src/index.html"), s("./src/utils/index.js"), s("./src/js/main.js")
    }()
}();